"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Avatar = void 0;

var _react = _interopRequireWildcard(require("react"));

var _LazyImage = require("../Image/LazyImage");

var _Avatar = require("./Avatar.shared");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/** An circular Avatar component containing an image or initials */
var Avatar = function Avatar(_ref) {
  var src = _ref.src,
      initials = _ref.initials,
      _ref$lazyLoad = _ref.lazyLoad,
      lazyLoad = _ref$lazyLoad === void 0 ? false : _ref$lazyLoad,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "md" : _ref$size,
      renderFallback = _ref.renderFallback,
      _onError = _ref.onError;

  var _sizeValue = (0, _Avatar.sizeValue)(size),
      diameter = _sizeValue.diameter;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      useFallback = _useState2[0],
      setUseFallback = _useState2[1];

  return _react.default.createElement(_Avatar.BaseAvatar, {
    src: src,
    initials: initials,
    size: size,
    renderAvatar: function renderAvatar() {
      return renderFallback && useFallback ? renderFallback({
        diameter: diameter
      }) : _react.default.createElement(_LazyImage.LazyImage, {
        onError: function onError(e) {
          if (_onError) {
            _onError(e);
          }

          setUseFallback(true);
        },
        preload: !lazyLoad,
        width: diameter,
        height: diameter,
        borderRadius: diameter,
        src: src
      });
    }
  });
};

exports.Avatar = Avatar;
Avatar.displayName = "Avatar";
//# sourceMappingURL=Avatar.js.map